<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="名称" prop="evaluateItemName">
        <el-input v-model="dataForm.evaluateItemName" placeholder="评价项名称"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="dataForm.evaluateItemType" placeholder="请选择">
          <el-option label="减分项" :value=itemType.MINUS></el-option>
          <el-option label="加分项" :value=itemType.ADD></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分数">
        <el-input-number v-model="dataForm.score" :min="1" label="分数"></el-input-number>
      </el-form-item>
      <el-form-item label="选择范围">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="gradeId" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="grade in checkedGrade" :label="grade.id" :key="grade.id">{{grade.title}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { itemType } from '@/constant'
import { Container } from 'element-ui'
export default {
  data () {
    return {
      lastAffiliatedItemId:'',
      ids:[],
      //全选
      checkAll:false,
      //复选框数据
      checkedGrade:[],
      //年级Id
      gradeId:[],
      //全选判断
      isIndeterminate:false,
      visible: false,
      dataForm: {
        id: '',
        evaluateItemName: '',
        examineItemId: '',
        examineItemName: '',
        evaluateItemType: 1,
        score: '',
        schoolId: '',
        noteSet: '',
        pictureSet: '',
        deleted: '',
        affiliatedItemId:''
      },
      itemType
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        console.log(this.dataForm)
        if (this.dataForm.id) {
          this.getInfo()
        }
        this.getClass()
        this.gradeId = []
        console.log(this.lastAffiliatedItemId)
        console.log(this.dataForm.id)
      })
    },
    //获取年段信息
    getClass(){
      this.$http.get('/grade/getList/').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        console.log('年段信息',res.data)
        this.checkedGrade = res.data
        console.log('this.checkedGrade',this.checkedGrade)
        //修改回显
        if(this.dataForm.id){
          this.gradeId = this.lastAffiliatedItemId.split(',')
        }
        //修改回显
        if(this.gradeId.length === this.checkedGrade.length && this.dataForm.id){
          this.checkAll = true
        }else{
          //新增回显
          this.checkAll = false
          if(this.dataForm.id){
            this.isIndeterminate = true
          }else{
            this.isIndeterminate = false
          }
          console.log(this.isIndeterminate)
        }
        console.log(this.checkAll)
        console.log(this.isIndeterminate)
        console.log(this.gradeId)
      }).catch(() => {})
    },
    //全选按钮
    handleCheckAllChange(val){
      console.log(val)
      this.ids = []
      this.checkedGrade.forEach((item) => {
          this.ids.push(item.id);
        });
      this.gradeId = val ? this.ids : []
      console.log(this.gradeId)
      this.isIndeterminate = false;
      console.log(this.isIndeterminate)
    },
    //选择年级监视
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkedGrade.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedGrade.length;
    },
    // 获取信息
    getInfo () {
      console.log('1',this.dataForm)
      this.$http.get('/thumb/thumbEvaluateItem/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        console.log(res.data)
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        console.log('2',this.dataForm)
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        // this.gradeId.toString()
        this.dataForm.affiliatedItemId = this.gradeId.toString()
        console.log(this.dataForm)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/thumb/thumbEvaluateItem/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
